// extracted by mini-css-extract-plugin
export default {"tab":"ChipTab_tab__uxgT-","tab--active":"ChipTab_tab--active__bU+eQ"};